import React from "react";

type Headline1Props = {
  children: string;
  light?: boolean;
};

const Headline1 = ({ children, light = false }: Headline1Props) => (
  <div className={`text-4xl mb-5 ${light ? "text-light" : "text-dark"}`}>
    {children}
  </div>
);

export default Headline1;
